module.exports = __webpack_public_path__ + "static/img/online.a7689a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online.png
// module id = IxiR
// module chunks = 0